<div class="modal-header">
    <h4 class="modal-title pull-left">Consent</h4>
      <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
      </button>
</div>
<div class="modal-body">
    To process your claim, please indicate below if you consent to CMFG Life Insurance Company:  
    <br/><br/>
    •	collecting and processing personal information concerning your physical and/or mental health;
    <br/>
    •	disclosing your personal information to a consulting medical professional for purposes of processing your claim;
    <br/>
    •	transferring (if applicable) your personal information to the United States 
    <br/><br/>
    You may choose not to provide your consent in connection with your claim. If you do not consent, we will be unable to process your claim or determine benefits to which you might be otherwise be entitled under your coverage. 
    <br/><br/>
    You may withdraw your consent at any time. If you withdraw your consent, we will no longer process your personal information in connection with your claim.
    <br/><br/>
    To withdraw your consent, or to speak to a claim specialist, please contact us at Members.Claims@trustage.com or 1.800.621.6323.  Hours of operation: 8am to 5pm (Central Standard Time) Monday through Friday.
</div>
<div class="modal-footer">
    <button
      role="button"
      name="acceptEConsentButton"
      id="acceptEConsentButton"
      class="btn btn-primary"
      (click)="acceptConsentAndCloseModal()">I Accept</button>
    <button
      role="button"
      name="declineEConsentButton"
      id="declineEConsentButton"
      class="btn btn-secondary"
      (click)="declineConsentAndCloseModal()">I Decline</button>
</div>